module.exports = __webpack_public_path__ + "img/introduction_img.621dbe99.png";